import { useState } from 'react'
import BannerLogin from '../../../component/BannerLogin/BannerLogin'
import { getApiUrl } from '../../../api/api'
import { Notify } from '../../../component/Notify'

function DangKy ({ tab, settab }) {
  const [isPassword, setisPassword] = useState(true)
  const [isRepassword, setisRepassword] = useState(true)
  const [notiMessage, setNotiMessage] = useState('')
  const [type, settype] = useState('')

  const [formData, setFormData] = useState({
    inviteCode: '',
    username: '',
    password: '',
    confirmPassword: '',
    fullName: '',
    phone: '',
    termsAccepted: true
  })
const [notifyMessage, setNotifyMessage] = useState("");
  const [notifyType, setNotifyType] = useState("error");
  const handleInputChange = e => {
    const { name, value, type, checked } = e.target
    let newValue = type === 'checkbox' ? checked : value

    if (name === 'username') {
      newValue = newValue.replace(/\s/g, '')
    }

    setFormData(prev => ({
      ...prev,
      [name]: newValue
    }))
  }
  const handleSubmit = async e => {
    e.preventDefault()

    const phoneRegex = /^0\d{9}$/
    if (!phoneRegex.test(formData.phone)) {
       setNotifyMessage("Số điện thoại không hợp lệ!");
      setNotifyType("error");
      return
    }

    if (formData.password !== formData.confirmPassword) {
       setNotifyMessage("Mật khẩu xác nhận không khớp!");
      setNotifyType("error");
      return
    }

    try {
      const response = await fetch(`${getApiUrl('backend')}/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: formData.username,
          password: formData.password,
          code: formData.inviteCode,
          phone: formData.phone
        })
      })

      const data = await response.json()

      if (!response.ok) {
        setNotiMessage(data.message || 'Đăng ký thất bại')
        settype('error')
        return
      }
      settab('Đăng nhập')
       setNotifyMessage("Đăng ký thành công!");
      setNotifyType("success");
      console.log('User:', data)
    } catch (err) {
      console.error('Lỗi khi đăng ký:', err)
      setNotiMessage('Có lỗi xảy ra, vui lòng thử lại sau.')
      settype('error')
    }
  }

  return (
    <>
      {notiMessage && (
        <Notify message={notiMessage} setcontent={setNotiMessage} type={type} />
      )}

      <div className='reg_form_mobile'>
        <BannerLogin />
        <form onSubmit={handleSubmit}>
          <div className='login_form_input_item'>
            <div className='input_wrapper'>
              <div className='icon_magt_input icon_input'></div>
              <input
                type='text'
                className='input_login_form'
                placeholder='Mã giới thiệu'
                name='code'
                value={formData.inviteCode}
                onChange={handleInputChange}
              />
            </div>

            <div className='input_wrapper'>
              <div className='icon_account_input icon_input'></div>
              <input
                type='text'
                className='input_login_form'
                placeholder='Tên đăng nhập'
                name='username'
                onChange={handleInputChange}
                onKeyDown={e => {
                  if (e.key === ' ') {
                    e.preventDefault()
                  }
                }}
                required
              />
            </div>
            <div className='input_wrapper'>
              <div className='icon_account_input icon_input'></div>
              <input
                type='text'
                className='input_login_form'
                placeholder='Số điện thoại'
                name='phone'
                value={formData.phone}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className='input_wrapper'>
              <div className='icon_password_input icon_input'></div>
              <input
                type={isPassword ? 'password' : 'text'}
                className='input_login_form'
                placeholder='Mật khẩu'
                name='password'
                value={formData.password}
                onChange={handleInputChange}
                required
              />
              <div
                className='icon-eyes-container'
                onClick={() => setisPassword(!isPassword)}
              >
                <i className='iconeyes_svg'>
                  {isPassword ? (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='100%'
                      height='100%'
                      viewBox='0 0 20 20'
                      fill='none'
                    >
                      <path
                        d='M2.72727 4.77405L3.65818 3.83331L15.8182 16.2185L14.8945 17.1666L12.6545 14.8852C11.8182 15.1666 10.9309 15.3148 10 15.3148C6.36364 15.3148 3.25818 13.0111 2 9.75924C2.50182 8.45553 3.30182 7.30739 4.32 6.39628L2.72727 4.77405ZM10 7.53702C11.205 7.53702 12.1818 8.53194 12.1818 9.75924C12.1818 10.0185 12.1382 10.2703 12.0582 10.5L9.27273 7.66294C9.49818 7.58146 9.74545 7.53702 10 7.53702ZM10 4.20368C13.6364 4.20368 16.7418 6.50739 18 9.75924C17.4036 11.3 16.3927 12.6333 15.0909 13.6037L14.0582 12.5444C15.0473 11.8481 15.8618 10.9 16.4145 9.75924C15.2145 7.27035 12.7345 5.68516 10 5.68516C9.20727 5.68516 8.42909 5.8185 7.70182 6.05554L6.58182 4.9222C7.62909 4.46294 8.78545 4.20368 10 4.20368ZM3.58545 9.75924C4.78545 12.2481 7.26545 13.8333 10 13.8333C10.5018 13.8333 10.9964 13.7815 11.4545 13.6778L9.79636 11.9815C8.75636 11.8704 7.92727 11.0259 7.81818 9.96665L5.34545 7.44072C4.62545 8.07035 4.02182 8.85554 3.58545 9.75924Z'
                        fill='currentColor'
                      ></path>
                    </svg>
                  ) : (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='100%'
                      height='100%'
                      viewBox='0 0 20 20'
                      fill='none'
                    >
                      <g>
                        <path
                          d='M10.01 11.89C11.214 11.89 12.19 10.914 12.19 9.71003C12.19 8.50605 11.214 7.53003 10.01 7.53003C8.80602 7.53003 7.83 8.50605 7.83 9.71003C7.83 10.914 8.80602 11.89 10.01 11.89Z'
                          fill='currentColor'
                        ></path>
                        <path
                          d='M16.39 12.37C16.51 12.23 16.65 12.09 16.76 11.94C16.93 11.72 17.07 11.49 17.22 11.25C17.3 11.13 17.38 11.02 17.45 10.89C17.66 10.52 17.84 10.14 17.99 9.75C17.85 9.38 17.67 9.02 17.48 8.67C17.42 8.57 17.36 8.47 17.3 8.37C17.16 8.13 17.01 7.9 16.84 7.68C16.75 7.56 16.67 7.45 16.57 7.34C16.42 7.15 16.25 6.98 16.08 6.8C15.97 6.69 15.86 6.57 15.75 6.46C15.73 6.44 15.71 6.42 15.69 6.4C15.12 5.89 14.36 5.41 13.52 4.99C13.52 4.99 12.87 4.68 12.59 4.6C12.23 4.48 11.85 4.4 11.47 4.33C11.37 4.31 11.27 4.3 11.17 4.28C10.78 4.22 10.39 4.19 9.98 4.19C9.57 4.19 9.18 4.23 8.79 4.28C8.69 4.29 8.59 4.31 8.49 4.33C8.11 4.4 7.74 4.48 7.37 4.6C7.09 4.69 6.53 4.91 6.53 4.91C5.7 5.28 4.99 5.78 4.32 6.38C4.31 6.38 4.3 6.39 4.28 6.4C4.26 6.42 4.24 6.44 4.22 6.46C4.1 6.57 4 6.68 3.89 6.8C3.72 6.97 3.56 7.15 3.4 7.34C3.31 7.45 3.22 7.56 3.13 7.68C2.97 7.9 2.81 8.13 2.67 8.37C2.61 8.47 2.55 8.56 2.49 8.67C2.3 9.02 2.12 9.37 1.98 9.75C2.13 10.15 2.32 10.53 2.52 10.89C2.59 11.01 2.68 11.13 2.75 11.25C2.9 11.48 3.04 11.72 3.21 11.94C3.33 12.09 3.46 12.22 3.58 12.37C3.73 12.54 3.87 12.71 4.02 12.86C4.2 13.03 4.39 13.19 4.58 13.34C4.68 13.42 4.77 13.52 4.88 13.6C6.31 14.67 8.06 15.31 9.96 15.31C11.86 15.31 13.62 14.66 15.04 13.59C15.15 13.52 15.24 13.42 15.34 13.34C15.53 13.18 15.72 13.03 15.9 12.86C16.06 12.71 16.2 12.53 16.34 12.37H16.39ZM15.93 10.6C15.86 10.71 15.78 10.81 15.7 10.91C15.58 11.07 15.47 11.22 15.34 11.37C15.25 11.48 15.15 11.57 15.05 11.67C14.92 11.8 14.8 11.93 14.66 12.05C14.55 12.14 14.44 12.23 14.33 12.32C13.42 13.03 12.35 13.52 11.2 13.72C11.09 13.74 10.98 13.76 10.87 13.77C10.58 13.81 10.29 13.83 9.99 13.83C9.69 13.83 9.4 13.8 9.11 13.77C9 13.76 8.89 13.74 8.78 13.72C7.63 13.52 6.56 13.03 5.65 12.32C5.54 12.23 5.43 12.15 5.32 12.05C5.18 11.93 5.06 11.8 4.93 11.67C4.83 11.57 4.73 11.48 4.64 11.37C4.51 11.22 4.4 11.07 4.28 10.91C4.2 10.81 4.12 10.71 4.05 10.6C3.87 10.33 3.71 10.05 3.57 9.76C3.71 9.48 3.86 9.21 4.03 8.95C4.15 8.76 4.29 8.59 4.43 8.42C5.34 7.27 6.56 6.42 7.94 6C8.07 5.96 8.19 5.94 8.32 5.91C8.51 5.86 8.7 5.81 8.9 5.78C9.26 5.73 9.62 5.69 9.98 5.69C10.34 5.69 10.71 5.72 11.06 5.78C11.26 5.81 11.45 5.86 11.64 5.91C11.77 5.94 11.9 5.97 12.02 6C13.49 6.45 14.78 7.38 15.7 8.64C15.78 8.75 15.87 8.86 15.94 8.98C16.1 9.23 16.26 9.49 16.39 9.76C16.25 10.05 16.09 10.33 15.91 10.6H15.93Z'
                          fill='currentColor'
                        ></path>
                      </g>
                    </svg>
                  )}
                </i>
              </div>
            </div>
            <div className='input_wrapper'>
              <div className='icon_password_input icon_input'></div>
              <input
                type={isRepassword ? 'password' : 'text'}
                name='confirmPassword'
                className='input_login_form'
                placeholder='Xác nhận mật khẩu'
                value={formData.confirmPassword}
                onChange={handleInputChange}
                required
              />
              <div
                className='icon-eyes-container'
                onClick={() => setisRepassword(!isRepassword)}
              >
                <i className='iconeyes_svg'>
                  {isRepassword ? (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='100%'
                      height='100%'
                      viewBox='0 0 20 20'
                      fill='none'
                    >
                      <path
                        d='M2.72727 4.77405L3.65818 3.83331L15.8182 16.2185L14.8945 17.1666L12.6545 14.8852C11.8182 15.1666 10.9309 15.3148 10 15.3148C6.36364 15.3148 3.25818 13.0111 2 9.75924C2.50182 8.45553 3.30182 7.30739 4.32 6.39628L2.72727 4.77405ZM10 7.53702C11.205 7.53702 12.1818 8.53194 12.1818 9.75924C12.1818 10.0185 12.1382 10.2703 12.0582 10.5L9.27273 7.66294C9.49818 7.58146 9.74545 7.53702 10 7.53702ZM10 4.20368C13.6364 4.20368 16.7418 6.50739 18 9.75924C17.4036 11.3 16.3927 12.6333 15.0909 13.6037L14.0582 12.5444C15.0473 11.8481 15.8618 10.9 16.4145 9.75924C15.2145 7.27035 12.7345 5.68516 10 5.68516C9.20727 5.68516 8.42909 5.8185 7.70182 6.05554L6.58182 4.9222C7.62909 4.46294 8.78545 4.20368 10 4.20368ZM3.58545 9.75924C4.78545 12.2481 7.26545 13.8333 10 13.8333C10.5018 13.8333 10.9964 13.7815 11.4545 13.6778L9.79636 11.9815C8.75636 11.8704 7.92727 11.0259 7.81818 9.96665L5.34545 7.44072C4.62545 8.07035 4.02182 8.85554 3.58545 9.75924Z'
                        fill='currentColor'
                      ></path>
                    </svg>
                  ) : (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='100%'
                      height='100%'
                      viewBox='0 0 20 20'
                      fill='none'
                    >
                      <g>
                        <path
                          d='M10.01 11.89C11.214 11.89 12.19 10.914 12.19 9.71003C12.19 8.50605 11.214 7.53003 10.01 7.53003C8.80602 7.53003 7.83 8.50605 7.83 9.71003C7.83 10.914 8.80602 11.89 10.01 11.89Z'
                          fill='currentColor'
                        ></path>
                        <path
                          d='M16.39 12.37C16.51 12.23 16.65 12.09 16.76 11.94C16.93 11.72 17.07 11.49 17.22 11.25C17.3 11.13 17.38 11.02 17.45 10.89C17.66 10.52 17.84 10.14 17.99 9.75C17.85 9.38 17.67 9.02 17.48 8.67C17.42 8.57 17.36 8.47 17.3 8.37C17.16 8.13 17.01 7.9 16.84 7.68C16.75 7.56 16.67 7.45 16.57 7.34C16.42 7.15 16.25 6.98 16.08 6.8C15.97 6.69 15.86 6.57 15.75 6.46C15.73 6.44 15.71 6.42 15.69 6.4C15.12 5.89 14.36 5.41 13.52 4.99C13.52 4.99 12.87 4.68 12.59 4.6C12.23 4.48 11.85 4.4 11.47 4.33C11.37 4.31 11.27 4.3 11.17 4.28C10.78 4.22 10.39 4.19 9.98 4.19C9.57 4.19 9.18 4.23 8.79 4.28C8.69 4.29 8.59 4.31 8.49 4.33C8.11 4.4 7.74 4.48 7.37 4.6C7.09 4.69 6.53 4.91 6.53 4.91C5.7 5.28 4.99 5.78 4.32 6.38C4.31 6.38 4.3 6.39 4.28 6.4C4.26 6.42 4.24 6.44 4.22 6.46C4.1 6.57 4 6.68 3.89 6.8C3.72 6.97 3.56 7.15 3.4 7.34C3.31 7.45 3.22 7.56 3.13 7.68C2.97 7.9 2.81 8.13 2.67 8.37C2.61 8.47 2.55 8.56 2.49 8.67C2.3 9.02 2.12 9.37 1.98 9.75C2.13 10.15 2.32 10.53 2.52 10.89C2.59 11.01 2.68 11.13 2.75 11.25C2.9 11.48 3.04 11.72 3.21 11.94C3.33 12.09 3.46 12.22 3.58 12.37C3.73 12.54 3.87 12.71 4.02 12.86C4.2 13.03 4.39 13.19 4.58 13.34C4.68 13.42 4.77 13.52 4.88 13.6C6.31 14.67 8.06 15.31 9.96 15.31C11.86 15.31 13.62 14.66 15.04 13.59C15.15 13.52 15.24 13.42 15.34 13.34C15.53 13.18 15.72 13.03 15.9 12.86C16.06 12.71 16.2 12.53 16.34 12.37H16.39ZM15.93 10.6C15.86 10.71 15.78 10.81 15.7 10.91C15.58 11.07 15.47 11.22 15.34 11.37C15.25 11.48 15.15 11.57 15.05 11.67C14.92 11.8 14.8 11.93 14.66 12.05C14.55 12.14 14.44 12.23 14.33 12.32C13.42 13.03 12.35 13.52 11.2 13.72C11.09 13.74 10.98 13.76 10.87 13.77C10.58 13.81 10.29 13.83 9.99 13.83C9.69 13.83 9.4 13.8 9.11 13.77C9 13.76 8.89 13.74 8.78 13.72C7.63 13.52 6.56 13.03 5.65 12.32C5.54 12.23 5.43 12.15 5.32 12.05C5.18 11.93 5.06 11.8 4.93 11.67C4.83 11.57 4.73 11.48 4.64 11.37C4.51 11.22 4.4 11.07 4.28 10.91C4.2 10.81 4.12 10.71 4.05 10.6C3.87 10.33 3.71 10.05 3.57 9.76C3.71 9.48 3.86 9.21 4.03 8.95C4.15 8.76 4.29 8.59 4.43 8.42C5.34 7.27 6.56 6.42 7.94 6C8.07 5.96 8.19 5.94 8.32 5.91C8.51 5.86 8.7 5.81 8.9 5.78C9.26 5.73 9.62 5.69 9.98 5.69C10.34 5.69 10.71 5.72 11.06 5.78C11.26 5.81 11.45 5.86 11.64 5.91C11.77 5.94 11.9 5.97 12.02 6C13.49 6.45 14.78 7.38 15.7 8.64C15.78 8.75 15.87 8.86 15.94 8.98C16.1 9.23 16.26 9.49 16.39 9.76C16.25 10.05 16.09 10.33 15.91 10.6H15.93Z'
                          fill='currentColor'
                        ></path>
                      </g>
                    </svg>
                  )}
                </i>
              </div>
            </div>
          </div>
          <button className='login_btn_mobile' type='submit'>
            Đăng Ký
          </button>
        </form>
         <Notify
                message={notifyMessage}
                type={notifyType}
                duration={3000}
                setcontent={setNotifyMessage}
              />
      </div>
    </>
  )
}

export default DangKy
